import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=0c158c8f"
import script from "./ResetPasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPasswordForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports